export { default as FooterText } from './FooterText';
